export interface RegisterCorporateFacilityRequestDto {
  facilityName: string;
  facilityTypeId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  stateCode: string;
  zipCode: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  position?: string;
  email?: string;
  password?: string;
  confirmPassword?: string;
  corporateAdminId?: string;
}

export interface RegisterCorporateFacilityResponseDto {
  facilityId: string;
  facilityName: string;
  corporationId: string;
  locationId: number;
  facilityAdminId: string;
  adminUserId: string;
  adminEmail: string;
  isNewUser: boolean;
  message: string;
}
